exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message_text{padding:15px 10px 0}.message_btngrounp{padding:0 0 6px;text-align:center}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/containers/App/components/MessageForm/style.css
 ** module id = 815
 ** module chunks = 73
 **/